module.exports = __webpack_public_path__ + "img/dots.7fe15bd0.svg";